import { render } from "./perjudicados_lista.vue?vue&type=template&id=25e7adfa"
import script from "./perjudicados_lista.vue?vue&type=script&lang=js"
export * from "./perjudicados_lista.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__